import type { FolderImportPreview } from '@st/sdk'
import { match } from '@st/pattern'

export const FOLDER_IMPORT_POLL_INTERVAL = '2000 millis'

export type ImportFailure = FolderImportPreview['failedRecords'][number]

export function selFailureMessage(failure: ImportFailure) {
  return failure.message ?? failureMessage(failure)
}

function failureMessage(failure: ImportFailure) {
  return match(failure.errorCode)
    .with('unsupported_record', () => {
      return `Generating a binder from a ${failure.taxYear} ${failure.returnType} return is not supported.`
    })
    .with(
      'empty_record',
      () => `No data was found for the client ${failure.id} in the backup file.`
    )
    .with(
      'internal_error',
      () =>
        'An unexpected error occurred. This may be a bug in StanfordTax.\nPlease contact support using the blue chat bubble\nif you would like someone to look into it.'
    )
    .exhaustive()
}

export function isFolderImportReady(importState: { status: string }) {
  return ['completed', 'completed_with_errors', 'incomplete', 'failed'].includes(importState.status)
}

export function selDefaultJobIds(jobs: FolderImportPreview['folders']) {
  return jobs
    .filter((job) => job.existingFolderId == null)
    .filter((job) => isDefaultSelectedJob(job))
    .map((job) => job.taxReturnId)
}

export function selDisabledReason(job: FolderImportPreview['folders'][number]) {
  if (job.existingFolderId != null) return 'This client has already been imported'
  return undefined
}

function isDefaultSelectedJob(job: FolderImportPreview['folders'][number]) {
  // ProSystem encodes record version in providerId (e.g. "24I:9329-000:V1").
  // We preselect only V1 to avoid importing superseded versions by default.
  if (job.sourceProvider == 'prosystem') {
    return job.sourceProviderId?.endsWith(':V1') == true
  }
  return true
}
